<template>
  <div>
    <h1 class="headline">{{ headerText }}</h1>
    <p>{{ snippet }}</p>

    <!-- If input fields are disabled, only display text -->
    <div v-if="!isDisableInputs">
      <div v-if="addressInputType === 'text'">
        <mdl-textfield
          field-id="inputUnit"
          :label="addressLabel"
          :is-disabled="isDisableInputs"
          :bvalue="ownership.address"
          placeholder=""
          @inputting="setOwnershipAddress"
          @enter-pressed="focusNextInput"
        />
      </div>
      <div v-else>
        <address-select
          :label="addressLabel"
          :addresses="meeting.addresses"
          :address="ownership.address"
        />
      </div>

      <mdl-textfield
        field-id="inputAddress"
        :label="unitLabel"
        :is-disabled="isDisableInputs"
        :bvalue="ownership.unit"
        placeholder="eg. Suite 1408"
        @inputting="setOwnershipUnit"
        @enter-pressed="focusNextInput"
      />

      <mdl-textfield
        field-id="contactName"
        :label="nameLabelText"
        :is-disabled="isDisableInputs"
        :bvalue="contact.name"
        placeholder="eg. Lisa Simpson"
        @inputting="updateInput"
        @enter-pressed="focusNextInput"
      />

      <mdl-textfield
        field-id="contactEmail"
        type="email"
        placeholder="eg. lisa.simpson@example.com"
        :label="emailLabelText"
        :is-disabled="isDisableInputs"
        :bvalue="contact.email"
        @inputting="updateInput"
        @enter-pressed="focusNextInput"
      />
    </div>

    <!-- If inputs disabled -->
    <div v-else>
      <mdl-displayfield
        field-id="inputUnit"
        :label="addressLabel"
        :bvalue="ownership.address"
        placeholder=""
      />

      <mdl-displayfield
        field-id="inputAddress"
        :label="unitLabel"
        :bvalue="ownership.unit"
        placeholder=""
      />

      <mdl-displayfield
        field-id="contactName"
        placeholder=""
        :label="nameLabelText"
        :bvalue="contact.name"
      />

      <mdl-displayfield
        field-id="contactEmail"
        type="email"
        placeholder=""
        :label="emailLabelText"
        :bvalue="contact.email"
      />
    </div>

    <div class="App-buttons">
      <button-component direction="back" value="Back"></button-component>
      <button-component
        color="primary"
        value="Next Step"
        :is-disabled="isMissingRequiredFields"
        field-id="buttonOwnershipNext"
      ></button-component>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ButtonComponent from '@/components/Button.vue';
import mdlTextfield from '@/components/mdlTextfield.vue';
import mdlDisplayfield from '@/components/mdlDisplayfield';
import AddressSelect from '@/components/Ownership/AddressSelect.vue';
import {isEmail} from 'validator';

import {mapActions, mapGetters} from 'vuex';

export default {
  components: {
    AddressSelect,
    ButtonComponent,
    mdlTextfield,
    mdlDisplayfield
  },
  computed: {
    ...mapGetters({
      blockUnverifiedVoting: 'blockUnverifiedVoting',
      ownership: 'ownership/ownership',
      meeting: 'meeting/meeting',
      contact: 'contact/contact',
      displayOptions: 'displayOptions'
    }),
    isMissingRequiredFields() {
      return (
        !this.ownership.unit.trim() ||
        !this.ownership.address.trim() ||
        !this.contact.name.trim() ||
        !this.contact.email.trim() ||
        this.isValidEmail
      );
    },
    isValidEmail() {
      return !isEmail(this.contact.email);
    },
    isDisableInputs() {
      // Disable inputs when unverified voting is blocked or the inputs are
      // explicitly disabled.
      return (
        this.blockUnverifiedVoting ||
        _.get(this.displayOptions, 'ownership.disable_inputs', false)
      );
    }
  },
  data() {
    return {
      customOptions: {},
      headerText: 'What is your ownership information?',
      snippet: '',
      addressLabel: 'Your Suite Address',
      unitLabel: 'Your Suite Number',
      unitInputType: null,
      addressInputType: null,
      nameLabelText: 'Your Name On Title',
      emailLabelText: 'Your Email Address',
      nextInputFieldArray: [
        'inputUnit',
        'inputAddress',
        'contactName',
        'contactEmail',
        'buttonOwnershipNext'
      ]
    };
  },
  methods: {
    ...mapActions('ownership', ['setOwnershipUnit', 'setOwnershipAddress']),
    ...mapActions('contact', ['setContactItem']),
    focusNextInput(currentInput) {
      let currentIndex = _.findIndex(this.nextInputFieldArray, function(
        fieldName
      ) {
        return fieldName === currentInput;
      });
      const nextInput = this.nextInputFieldArray[currentIndex + 1];
      this.$events.$emit('go-input', nextInput);
    },
    updateInput(value, prop) {
      this.setContactItem({prop, value});
    },
    setCustomText() {
      if (!_.has(this.displayOptions, 'contact')) {
        return;
      }
      const contactOpts = this.displayOptions.contact;
      this.nameLabelText = contactOpts.name_label_text || this.nameLabelText;
      this.emailLabelText = contactOpts.email_label_text || this.emailLabelText;
    },
    setCustomOptions() {
      if (!_.has(this.displayOptions, 'ownership')) {
        return;
      }
      const opts = this.displayOptions.ownership;
      this.customOptions = opts;

      // Only use custom text for the ones provided, otherwise use defaut
      this.headerText = opts.header_text || this.headerText;
      this.addressLabel = opts.address_label_text || this.addressLabel;
      this.unitLabel = opts.unit_label_text || this.unitLabel;
      this.snippet = opts.snippet || this.snippet;

      // Set input types if specified
      this.addressInputType = opts.address_input_type;
    }
  },
  mounted() {
    this.setCustomOptions();
    this.setCustomText();
    this.$nextTick(() => {
      componentHandler.upgradeAllRegistered();
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Ownership/Ownership.vue